import { css } from "@emotion/react";

import * as layers from "@styles/emotion-styles/layers";

export const content = () => css`
  margin-top: 0.5rem;
  max-height: inherit;
  overflow-y: visible;
  top: calc(100% + 1.5rem);
  z-index: ${layers.indexDropdown};

  &:before {
    content: "";
    width: 100%;
    height: 0.5rem;
    background-color: transparent;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
